export class InspectionPermission {
    public INSP_Add_Unit: boolean = false;
    public INSP_Add: boolean = false;
    public INSP_Admin_Unit: boolean = false;
    public INSP_Admin: boolean = false;
    public INSP_View_Unit: boolean = false;
    public INSP_View: boolean = false;
    public INSP_Own: boolean = false;
}